import {api} from '../../store/api'

export default {
  methods: {
    initConfig: function () {
      const bounds = new mapboxgl.LngLatBounds();
      this.svgConfig.svgFileConfigs.forEach((svgConfig) => {
        if (svgConfig.svgFileType.fileType === 'MASTER') {
          this.masterBound = new mapboxgl.LngLatBounds(
            new mapboxgl.LngLat(svgConfig.neLongBound, svgConfig.neLatBound),
            new mapboxgl.LngLat(svgConfig.swLongBound, svgConfig.swLatBound)
          );

          if (svgConfig.poe && svgConfig.poe.lat && svgConfig.poe.lng) {
                  const poe = new mapboxgl.LngLat(svgConfig.poe.lng, svgConfig.poe.lat)
                  this.origin = poe;
          }
        }
        if (svgConfig.neLongBound && svgConfig.neLongBound !== 0) {
          const bound = new mapboxgl.LngLatBounds(
            new mapboxgl.LngLat(svgConfig.neLongBound, svgConfig.neLatBound),
            new mapboxgl.LngLat(svgConfig.swLongBound, svgConfig.swLatBound)
          );
          bounds.extend(bound);
          if (svgConfig.baseLayerUrl && svgConfig.baseLayerUrl !== '') {
            this.baseLayers.push({
              bound,
              url: svgConfig.baseLayerUrl,
            });
          }

          if (svgConfig.detailLayerUrl && svgConfig.detailLayerUrl !== '') {
            this.detailLayers.push({
              bound,
              url: svgConfig.detailLayerUrl,
            });
          }
        }
      });

      this.svgConfig.polygons.forEach((item) => {
        const geojson = [];
        item.geojson[0].forEach((coord, index) => {
          geojson.push([coord.lng, coord.lat]);
          if (index + 1 === item.geojson[0].length) {
            geojson.push([item.geojson[0][0].lng, item.geojson[0][0].lat]);
          }
        });

        const feature = {
          type: 'Feature',
          geometry: {
            type: 'Polygon',
            properties: {},
            coordinates: [geojson],
          },
        };
        this.stageGeoJson.features.push(feature);
      });

      let minZoom = 11;

      if (window.innerWidth < 600) {
        minZoom = 7
      }

      if (this.map === null || this.map === undefined) {
        this.map = new mapboxgl.Map({
          container: this.$refs[this.container],
          style: 'mapbox://styles/mapbox/streets-v11',
          center: bounds.getCenter(),
          zoom: 18,
          minZoom: minZoom,
          pitchWithRotate: true,
        });
      }

      this.map.addControl(new mapboxgl.NavigationControl());

      this.map.on('error', () => {
        return null;
      });

      this.map.on('load', () => {
        this.placeLayer();
        this.fetchGeoJsonLots();
        this.fetchGeoJsonHome();
        this.mapObjects(this.svgConfig.objects);
      });
    },

    fetchGeoJsonLots: function () {
      api.fetchLotGeojson().then((res) => {
        this.lotGeoJson = res.data.geoJson;
        this.addLotShapes();
      })
    },

    fetchGeoJsonHome: function () {
      api.fetchPackageGeojsonAndHandlSummaryList().then((res) => {
        if (res && res.packageGeoJson) {
          this.addHomesShapes(res.packageGeoJson.geoJson, res.handlSummaryList);
        }
      });
    },

    mapObjects: function (objects) {
      objects.forEach((obj, index) => {
        const coords = [[]];
        obj.geojson[0].forEach((g) => {
          const coord = [g.lng, g.lat];
          coords[0].push(coord);
        });
        coords[0].push(coords[0][0]);
        let baseHeight = 0;
        const storeyHeight = obj.storeyHeight || 5;
        if (obj.baseHeight) {
          baseHeight = obj.baseHeight;
        }
        for (let i = baseHeight; i <= obj.height; i++) {
          const feature = {
            type: 'Feature',
            id: Math.floor(Math.random() * Math.floor(99999)) + i + index + 1,
            geometry: {
              type: 'Polygon',
              coordinates: coords,
            },
            properties: {
              height: storeyHeight * (i + 1),
              base_height: i * storeyHeight + 1 / 5,
              color: 'grey',
              interact: true,
              description: 'Level ' + i,
            },
          };
          this.apartmentGeoJson.features.push(feature);
        }
      });

      this.addApartmentShapes();
    },

    placeLayer: function () {
      if (this.baseLayers.length > 0) {
        this.baseLayers.forEach((layer) => {
          this.map.addSource('raster-tiles', {
            type: 'raster',
            tiles: [
              layer.url + '/{z}/{x}/{y}.png',
            ],
            tileSize: 256,
            minZoom: 16,
            maxZoom: 22,
          });
        });

        this.map.addLayer({
          id: 'terrain-data',
          type: 'raster',
          source: 'raster-tiles',
          minZoom: 16,
          maxZoom: 22,
          paint: {
            'raster-opacity': 1,
          },
        });
      }
    },

    assignColor: function (status) {
      status = status.toLowerCase();
      if (status === 'available') {
        return '#f0cd89';
      } else if (
        status === 'sold' ||
        status === 'closed' ||
        status === 'unknown'
      ) {
        return '#c3958e';
      } else if (status === 'future release' || status === 'unavailable') {
        return '#fff7eb';
      } else if (status === 'model') {
        return '#8b586a';
      } else if (status === 'hold' || status === 'reserved') {
        return '#86ABB5';
      } else if (status === 'spec' || status === 'contingent spec') {
        return '#688e9f'
      }
      else {
        console.log(status);
        return '#fff7eb';
      }
    },

    placeDetailLayer: function () {
      if (this.detailLayers.length > 0) {
        this.detailLayers.forEach((layer) => {
          this.map.addSource('detail-tiles', {
            type: 'raster',
            tiles: [
              // 'assets/detail/{z}/{x}/{y}.png'
              layer.url + '/{z}/{x}/{y}.png',
            ],
            tileSize: 256,
            minZoom: 16,
            maxZoom: 23,
          });
        });

        this.map.addLayer({
          id: 'detail-data',
          type: 'raster',
          source: 'detail-tiles',
          minZoom: 16,
          maxZoom: 22,
          paint: {
            'raster-opacity': 1,
          },
        });
      }
    },

    addApartmentShapes: function () {
      let hoveredObjectId;
      if (this.map.getSource('objects')) {
        this.map.removeLayer('obj');
        this.map.removeSource('objects');
      }

      this.map.addSource('objects', {
        type: 'geojson',
        data: this.apartmentGeoJson,
      });

      this.map.addLayer({
        id: 'obj',
        type: 'fill-extrusion',
        source: 'objects',
        minzoom: 15,
        paint: {
          'fill-extrusion-color': [
            'case',
            ['boolean', ['feature-state', 'hover'], false],
            '#e05858',
            '#f1f1f1',
          ],
          'fill-extrusion-height': ['get', 'height'],
          'fill-extrusion-base': ['get', 'base_height'],
          'fill-extrusion-opacity': 0.9,
        },
      });

      this.map.on('mousemove', 'obj', (e) => {
        if (e.features.length > 0) {
          const description = e.features[0].properties.description;
          this.map.getCanvas().style.cursor = 'pointer';
          if (hoveredObjectId) {
            this.map.setFeatureState(
              {source: 'objects', id: hoveredObjectId},
              {hover: false}
            );
          }

          hoveredObjectId = e.features[0].id;
          this.map.setFeatureState(
            {source: 'objects', id: hoveredObjectId},
            {hover: true}
          );
        }
      });

      this.map.on('mouseleave', 'obj', () => {
        this.map.getCanvas().style.cursor = '';
        if (hoveredObjectId) {
          this.map.setFeatureState(
            {source: 'objects', id: hoveredObjectId},
            {hover: false}
          );
        }
        hoveredObjectId = null;
      });
    },

    flyTo: function (lotId, mark) {
      this.viewBasedFilterLot.features = [];
      let lotGeo = this.filteredlotGeoJson.features.find(item => item.id === lotId)
      if (lotGeo) {
        const bounds = new mapboxgl.LngLatBounds();
        lotGeo.geometry.coordinates[0].forEach((cord) => {
          bounds.extend(new mapboxgl.LngLat(cord[0], cord[1]));
        });
        const payload = {
          point: bounds.getCenter(),
          features: {
            properties: {
              hnlproperties: JSON.stringify(lotGeo.properties.hnlproperties)
            }
          }
        }
        this.createLotMarker(payload);
        this.map.fitBounds(bounds, {
          maxZoom: 19,
        });
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/map/Config.js